import { createSelector } from "reselect";
import { AccountLOB, } from "../types";
import { getAllAccounts } from "./selectors";
import { filterAutoAccountsForDashboard, formatAutoAccountsForDropdown, } from "./utils";
/**
 * Returns all auto accounts or an empty array.
 */
var getAllAutoAccounts = createSelector(getAllAccounts, function (accounts) { var _a; return (_a = accounts === null || accounts === void 0 ? void 0 : accounts.filter(function (account) { return account.lob === AccountLOB.AUTO; })) !== null && _a !== void 0 ? _a : []; });
/**
 * Returns all auto accounts except if user declines bankruptcy notice,
 * then any bankrupt auto accounts are filtered out
 */
var getAllFilteredAutoAccounts = createSelector(getAllAutoAccounts, function (_, isBankruptcyAccepted) { return isBankruptcyAccepted; }, function (accounts, isBankruptcyAccepted) {
    return filterAutoAccountsForDashboard(accounts, isBankruptcyAccepted);
});
/**
 * Filters out auto accounts unable to be shown on accounts dropdown
 */
var getAutoAccountsForDropdown = createSelector(getAllFilteredAutoAccounts, function (accounts) {
    return formatAutoAccountsForDropdown(accounts);
});
export default {
    getAll: getAllAutoAccounts,
    getAllForDropdown: getAutoAccountsForDropdown,
    getAllFiltered: getAllFilteredAutoAccounts,
};
//# sourceMappingURL=auto.js.map